const modals = Object.freeze({
  supportModal: 'supportModal',
  changePasswordModal: 'changePasswordModal',
  deleteAccountModal: 'deleteAccountModal',
  uploadAvatarModal: 'uploadAvatarModal',
  editSocialMedia: 'editSocialMedia',
  editShippingAddress: 'editShippingAddress',
  declineInvite: 'declineInvite',
  leaveModal: 'leaveModal',
  mediaPreview: 'mediaPreview',
  statusInfoModal: 'statusInfo',
  supportSuccess: 'supportSuccess',
  interestFormSuccess: 'interestFormSuccess',
  submissionFormSuccess: 'submissionFormSuccess',
  welcome: 'welcome',
})

export default modals
